<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkFaq from "./BookmarkFAQ.svelte";
  import { Latestarticlesandvideos } from "../../../utils/Constant/Constant";
  import FaqHeadContent from "./FaqHeadContent.svelte";
  import QuestionFaq from "./QuestionFaq.svelte";
  import FeaturesFaq from "./FeaturesFaq.svelte";
  import LatestArticalFaq from "./LatestArticalFaq.svelte";
</script>
<BookmarkFaq />
<Container fluid>
    <div class="faq-wrap">
      <Row>
        <FaqHeadContent />
        <QuestionFaq />
        <FeaturesFaq />
        <Col lg="12" class="faq-articles"> 
          <div class="header-faq">
            <h5 class="mb-0">{Latestarticlesandvideos}</h5> 
          </div>
          <Row>
            <LatestArticalFaq />
          </Row>
        </Col>
      </Row>
    </div>
</Container>